import { type RouteComponentProps } from "react-router";

import { BTDropdown } from "@btnet/core-components";

import { BdsIconDotsThree } from "@buildertrend/components";

import { routes } from "utilities/routes";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTLinkRelative } from "commonComponents/btWrappers/BTLink/BTLink";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";
import { ContactInfoDisplayModal } from "commonComponents/utilities/HeaderInfo/ContactInfoButton/ContactInfoButton";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

interface IContactInfoMenuProps extends RouteComponentProps {
    jobId: number;
    parentUrl: string;
}

const ContactInfoMenu = (props: IContactInfoMenuProps) => (
    <>
        <BTMenu testid="ContactInfoMenu">
            <BTMenu.Item testid="contactInfoMenuItem">
                <BTLinkRelative to={routes.contact.getContactInfoDisplayLink()}>
                    View contact info
                </BTLinkRelative>
            </BTMenu.Item>
        </BTMenu>
        <RouteRelative
            path={routes.contact.contactInfoDisplay}
            render={() => <ContactInfoDisplayModal {...props} />}
        />
    </>
);

export const ContactInfoDropdown = (props: IContactInfoMenuProps) => (
    <BTDropdown testid="more-sub-actions-dropdown" overlay={<ContactInfoMenu {...props} />}>
        <BTButton
            data-testid="more-sub-actions"
            aria-label="More sub actions"
            type="tertiary"
            icon={<BdsIconDotsThree />}
        />
    </BTDropdown>
);
